import { useRef } from "react";

/**
 * Keeps a ref to the latest value, so elements handed to the page intro
 * (which only re-renders when its deps change) never call a stale closure.
 */
const useLatestRef = <T>(value: T) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};

export default useLatestRef;
